import ReactCountrySelect, { components } from 'react-select';
import classnames from 'classnames';
import find from 'lodash/find';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import type { DropdownIndicatorProps, SingleValue as ReactSelectSingleValue, SingleValueProps } from 'react-select';

import '../Select_.scss';
import './CountrySelect_.scss';
import '@components/Print/Print_.scss';

import countryLabels from './countryLables.json';

import { FieldTitle } from '../../FieldTitle';
import { MenuList, OptionType } from '../Select';
import { FlagIcon } from './FlagIcon';

// https://github.com/JedWatson/react-select#props
export interface CountrySelectParams {
    title?: string;
    disabled?: boolean;
    theme?: string;
}

interface Props extends CountrySelectParams {
    selectedCountry: string;
    countryOptions?: OptionType[];
    onCountrySelect(countryCode: string, data?: any): void;
}

const defaultCountryOptions: OptionType[] = [
    { value: 'RU', label: 'Россия' },
    ...sortBy(
        map(countryLabels, (label, value) => ({ label, value })),
        ({ label }) => label,
    ),
];

/* eslint-disable */
export function CountrySelect({
    selectedCountry,
    countryOptions = defaultCountryOptions,
    title,
    disabled,
    theme,
    onCountrySelect,
}: Props) {
    const className = classnames(['component_select__root', 'component_country_select__root', theme]);

    const value = find(countryOptions, option => option.value === selectedCountry) || { value: '-', label: '-' };

    const handleChange = (selectedItem: ReactSelectSingleValue<OptionType>) => {
        const option = selectedItem as OptionType<string, { mask?: string }>;

        onCountrySelect(option.value, option.mask);
    };

    return (
        <div className={className}>
            {title && <FieldTitle title={title} />}
            <ReactCountrySelect
                placeholder={'-'}
                options={countryOptions}
                value={value}
                isDisabled={disabled}
                isSearchable={true}
                className={`${className} hide_on_print`}
                classNamePrefix={'react-select'}
                components={{ DropdownIndicator, MenuList, SingleValue }}
                onChange={handleChange}
            />
            <div className={classnames(['for_print', 'country_print_lable'])}>{value?.label ?? ''}</div>
        </div>
    );
}

const DropdownIndicator = (props: DropdownIndicatorProps<OptionType, false>) => {
    return (
        <components.DropdownIndicator {...props}>
            <div className={'component_select__open_icon'} />
        </components.DropdownIndicator>
    );
};

const SingleValue = ({ children, ...props }: SingleValueProps<OptionType, false>) => {
    const countryCode = String(props.data.value ?? '').toUpperCase();

    const FlagIconComponent = FlagIcon[countryCode];

    return (
        <components.SingleValue {...props}>
            {FlagIconComponent ? (
                <div className={'component_country_select__icon__shadow'}>
                    <div className={'component_country_select__icon'}>
                        <FlagIconComponent />
                    </div>
                </div>
            ) : (
                countryCode
            )}
        </components.SingleValue>
    );
};

export default CountrySelect;
